import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-151" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-152" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-153" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-[#C9A24A] bg-[#520128] text-white font-bold text-[10px] sm:text-sm tracking-widest mb-4 sm:mb-6" data-id="element-154" data-mp="3d21ty23jwspu">
            SEWING &amp; PATTERN MAKING INSTRUCTOR <span className="text-[#E3C27A]" data-id="element-155" data-mp="3j9k9f79139e0">ATLAS</span>
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-[#520128] uppercase" data-id="element-156" data-mp="3o7c05xxxspgm">
            Solve <span className="text-[#8E2C5C]" data-id="element-157" data-mp="39a32ynlycrgz">Months of Sewing Class Planning</span>{' '}
            <span className="bg-[#520128] text-white px-2 box-decoration-clone" data-id="element-158" data-mp="3e7ux7oa2kpoc">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-159" data-mp="358rg2pugqkch">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-160" data-mp="2vglmxcsh5wvp" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-161" data-mp="2lk8qw89gj6xs">
          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-162" data-mp="n98d5mudb3nd">
            The Complete{' '}
            <span className="font-semibold text-[#8A6A2B]" data-id="element-163" data-mp="ddne9xklijhu">
              6-IN-1 Visual Sewing, Pattern Making &amp; Garment Construction System for Sewing Instructors, Pattern-Making Teachers &amp; Sewing Academies.
            </span>
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-164" data-mp="162m3tfr1snx6">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-165" data-mp="111ol9224lrv5">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700/80 mb-3" data-id="element-166" data-mp="3hrd8stumt7zd">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-167" data-mp="1xavzepf1qi9w">
                <CheckCircle size={14} className="text-[#8E2C5C]" data-id="element-168" data-mp="21a4ubxltom71" />
                <span className="font-medium" data-id="element-169" data-mp="269zj9vm1f1pg">{item}</span>
              </div>)}
          </div>

          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-170" data-mp="2b0fxhhxomrcv">
            <span className="font-semibold text-[#520128]" data-id="element-171" data-mp="2g0lsn835uvzp">6 Professional Visual Training Volumes</span> + 5
            Exclusive Bonuses — everything organized to help you plan, explain, demonstrate and assess every
            sewing class, pattern-making lesson, fitting session and studio workshop, from machine basics and fabrics to body measurements, pattern drafting, draping, garment construction, tailoring and alterations, from beginner to advanced, with more clarity, structure and confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-[#8A6A2B] mb-5 sm:mb-7" data-id="element-172" data-mp="zmc2c8fcyx68">
            FROM SEWING FUNDAMENTALS &amp; PATTERN DRAFTING TO GARMENT CONSTRUCTION, TAILORING &amp; TEACHING METHODS
          </p>

          <p className="text-xs text-slate-500" data-id="element-173" data-mp="3vjrre5zkhlpf">
            6 VISUAL VOLUMES · 300 TRAINING PAGES · 5 EXCLUSIVE BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}